import { render, staticRenderFns } from "./info-detail-modal.vue?vue&type=template&id=7d05c018&scoped=true"
import script from "./info-detail-modal.vue?vue&type=script&lang=js"
export * from "./info-detail-modal.vue?vue&type=script&lang=js"
import style0 from "./info-detail-modal.vue?vue&type=style&index=0&id=7d05c018&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d05c018",
  null
  
)

export default component.exports